import React from "react";
import PropTypes from "prop-types";
import reactStringReplace from "react-string-replace";

const Text = props => {
	return (
		<>
			{reactStringReplace(props.content, "®", match => (
				<sup key={"paragraph-" + match} className="copyright">
					®
				</sup>
			))}
		</>
	);
};

Text.propTypes = {
	content: PropTypes.string
};

export default Text;
